import { ScannerType } from "models/scanner-type";

// Scanners compiled into this build. `REACT_APP_SCANNERS` is a comma-separated
// list (e.g. "MICROBLINK_NEW,MICROBLINK_BLINKID") for a multi-scanner build with
// runtime selection. When unset it falls back to the single `REACT_APP_SCANNER`
// (the single-scanner setup most clients use). The first entry is the default /
// control arm and the fallback when the runtime A/B flag resolves to nothing valid.
const enabledScanners: ScannerType[] = (
  process.env.REACT_APP_SCANNERS ||
  process.env.REACT_APP_SCANNER ||
  ""
)
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean)
  .map((s) => ScannerType[s as keyof typeof ScannerType])
  .filter((s): s is ScannerType => s !== undefined);

// Kept as a non-null assertion so an unset value fails loudly at module load:
// an empty locale list would leave the app with no translations at all.
const supportedLocales = process.env.REACT_APP_SUPPORTED_LOCALES!.split(",")
  .map((l) => l.trim())
  .filter(Boolean);

const config = {
  // prettier-ignore
  client: process.env.REACT_APP_CLIENT!,
  supportedLocales,
  // Locale to land on when the URL asks for none, and the last resort of the
  // i18n fallback chain. Must come from the build: clients bundle different
  // locale sets (JetBlue ships bare "en"/"es"), so a hardcoded code would name
  // a lang pack that isn't there.
  defaultLocale:
    process.env.REACT_APP_DEFAULT_LOCALE?.trim() ||
    supportedLocales[0] ||
    "en-US",
  isIndexLoginDissalowed: process.env.REACT_APP_DISSALOW_INDEX_LOGIN === "true",
  enabledScanners,
  defaultScanner: enabledScanners[0],
  // growthbook
  growthbook: {
    tag: process.env.REACT_APP_GROWTHBOOK_TAG,
    apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
    apiKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
    isDebug: process.env.REACT_APP_GROWTHBOOK_DEBUG === "true",
  },
  // umami
  umami: {
    websiteId: process.env.REACT_APP_UMAMI_WEBSITE_ID,
  },
  // demo mode
  demoMode: process.env.REACT_APP_DEMO_MODE === "true",
  // Azure API Management gateway (e.g. JetBlue azrest*.jetblue.com)
  azureApiGateway: {
    subscriptionKey: process.env.REACT_APP_AZURE_APIM_SUBSCRIPTION_KEY,
  },
  // Google reCAPTCHA Enterprise (CreateAssessment on backend)
  recaptcha: {
    siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  },
};

// Growthbook value flag that selects which scanner a scan uses (A/B rollout).
export const SCANNER_FLAG = `${config.growthbook.tag}-scanner`;

export const AZURE_APIM_SUBSCRIPTION_KEY_HEADER = "Ocp-Apim-Subscription-Key";

export const getAzureApiGatewayHeaders = ():
  | Record<string, string>
  | undefined => {
  const subscriptionKey = config.azureApiGateway.subscriptionKey;
  if (!subscriptionKey) {
    return undefined;
  }

  return { [AZURE_APIM_SUBSCRIPTION_KEY_HEADER]: subscriptionKey };
};

export const HEADER_OFFSET = 64;

export default config;
